import v21Schema, {
  MigrationTypes as V21Types,
} from "../client/schemaVersions/v21.js";
import v22Schema, {
  MigrationTypes as V22Types,
} from "../client/schemaVersions/v22.js";
import { createMigration } from "@verdant-web/store";

export default createMigration<V21Types, V22Types>(
  v21Schema,
  v22Schema,
  async ({ migrate }) => {
    // add or modify migration logic here. you must provide migrations for
    // any collections that have changed field types or added new non-nullable
    // fields without defaults
    // await migrate('collectionName', async (old) => ({ /* new */ }));
  },
);
